import React from "react";

const backgroundImage='../../../assets/media/misc/auth-bg.png';
const myStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",  
    backgroundPosition: "center"
  };

function LoginAside(){
    return(
        <>
   
    <div className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover  bgi-position-center" style={myStyle}>
       
        <div className="d-flex flex-column flex-center p-6 p-lg-10 w-100">          
          
            <a href="/dashboard" className="mb-0 mb-lg-20">
               <h1 className="d-none d-lg-block text-white fs-2qx fw-bold text-center mb-7"> 
               School Finance
            </h1>                     
            </a>    
                        
            <img className="d-none d-lg-block mx-auto rounded-xl w-300px w-lg-75 w-xl-500px mb-10 mb-lg-20" src="../../../bgg.png" alt=""/>                 
        

         
            <h6 className="d-none d-lg-block text-white  text-center mb-7"> 
                Powered By <a href="https://infinitivelogic.com" target="_blank">INFINITIVE LOGIC</a>
            </h6>  
          

          
            
          
        </div>
       
    </div>
    </>
    );
}

export default LoginAside;

